import React from "react";
import { View, TextInput, ActivityIndicator } from "react-native";
import i18n from "../../locales/i18n";

interface Product {
  id_product: number;
  name: string;
  price_sell: string;
  price_bought: string;
  stock: number;
}

interface OtherProductInputProps {
  autherItem: string;
  setAutherItem: (item: string) => void;
  custumQunatity: string;
  handelAddProduct: () => void;
  locale: string;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isDropdownVisible: boolean;
  setIsDropdownVisible: (visible: boolean) => void;
  products: Product[];
  buttonSpinner: boolean;
  handleSelect: (item: Product) => void;
  SetOpenCam: (open: boolean) => void;
}

const OtherProductInput: React.FC<OtherProductInputProps> = ({
  autherItem,
  setAutherItem,
  custumQunatity,
  handelAddProduct,
  locale,
  handleSelect,
  isDropdownVisible,
  products,
  buttonSpinner,
}) => {
  return (
    <View className="mx-4">
      {/* Other Product Input - White rounded */}
      <View
        className="bg-white rounded-full border border-gray-300"
        style={{
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 1,
          },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 3,
        }}
      >
        <TextInput
          style={{
            fontSize: 16,
            height: 45,
            paddingHorizontal: 20,
            backgroundColor: "transparent",
            color: "#1F2937",
          }}
          className={`${locale === "ar" ? "text-right" : "text-left"}`}
          keyboardType="phone-pad"
          autoCapitalize="none"
          placeholder={i18n.t("unregisteredProduct")}
          placeholderTextColor="#9CA3AF"
          onChangeText={(text) => {
            setAutherItem(text);
          }}
          value={autherItem}
          onSubmitEditing={() => {
            if (handelAddProduct) {
              handelAddProduct();
            }
          }}
          returnKeyType="done"
        />
      </View>

      {buttonSpinner && <ActivityIndicator size="large" color="blue" />}
    </View>
  );
};

export default OtherProductInput;
